import { GridInputs } from "../../../../../components/Functional";

const getOfferInputs = ({ artists, offerStatuses, entities } = {}) => ({
  className: "grid grid-rows-2 gap-4",
  inputs: [
    {
      className: "grid grid-cols-1 gap-4 lg:grid-cols-4",
      inputs: [
        {
          label: "Date Start",
          name: "_offer.date.value.from",
          type: "date",
        },
        {
          label: "Date End",
          name: "_offer.date.value.to",
          type: "date",
        },
        {
          label: "Artist",
          name: "_offer._artwork._artist.id",
          options: artists?.map(artist => ({
            label: artist.name,
            value: artist.id,
          })),
          type: "multi-select",
        },
        {
          label: "Status",
          name: "_offer.statusId",
          options: offerStatuses?.map(item => ({
            label: item.description,
            value: item.id,
          })),
          type: "multi-select",
        },
        {
          label: "Selling Person",
          name: "_offer._offerSalesPerson.salesUserId",
          options: entities?.edges?.map(item => {
            return { label: item.name, value: item.id };
          }),
          type: "multi-select",
        },
        {
          hasOperator: true,
          operator: "gt",
          label: "Holds",
          name: "_offer.holdId",
          options: [{ label: "Include only contacts with holds", value: 0 }],
          singleCheckbox: true,
          uncheckedValue: null,
          type: "checkbox",
        },
      ],
    },
  ],
});

const Offers = props => {
  const { artists, entities, formik, offerStatuses } = props || {};

  const inputs = getOfferInputs({ artists, offerStatuses, entities });

  return <GridInputs formik={formik} {...inputs} />;
};

export default Offers;
export { getOfferInputs };
